// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1zWj5","productName":"Table_productName__2PZhw"};